import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { View, Text, Page } from '@react-pdf/renderer';
import { Notes, Orders, Both } from '@mummssoftware/utils/constants';
import { checkTrue } from '@mummssoftware/utils/utils';
import { PrintFooterPDFComponent } from '../Footer';
import { PrintHeaderPDFComponent } from '../Header';
import { fromDateToDate, styles, ios, pageOrientation, pageSize, safari } from '../../utils';
import { AllProgressNotesPDF } from './components/AllProgressNotesPDF';
import defaults from '../../translations/en.json';

var _ref = /*#__PURE__*/React.createElement(PrintFooterPDFComponent, null);

export const ProgressNotesPDF = ({
  dashboardPrintConfig,
  pdfProgressNotes,
  pdfPSOComponents,
  patient,
  browser
}) => {
  const shallowDashboardPrintConfigView = dashboardPrintConfig && _objectSpread({}, dashboardPrintConfig);

  const ProgressNotesPrintView = shallowDashboardPrintConfigView === null || shallowDashboardPrintConfigView === void 0 ? void 0 : shallowDashboardPrintConfigView.ProgressNotes;
  const ProgressNotesRadioView = ProgressNotesPrintView === null || ProgressNotesPrintView === void 0 ? void 0 : ProgressNotesPrintView.view;
  let printPN;
  let widgetTitle;
  let isCombined;
  let ordersPageConfig;

  if (ProgressNotesRadioView && pdfProgressNotes && pdfProgressNotes) {
    const config = ProgressNotesPrintView === null || ProgressNotesPrintView === void 0 ? void 0 : ProgressNotesPrintView.view;

    if (typeof config !== 'string' && config.includes(Orders)) {
      printPN = pdfProgressNotes.filter(x => checkTrue(x.isorder));
      widgetTitle = defaults.orders; // eslint-disable-next-line prefer-destructuring

      ordersPageConfig = config[1];
      isCombined = false;
    } else if (config === Notes) {
      printPN = pdfProgressNotes.filter(x => !checkTrue(x.isorder));
      widgetTitle = defaults.generalNotes;
      isCombined = false;
    } else if (config === Both) {
      const ordersPrintPN = pdfProgressNotes.filter(x => checkTrue(x.isorder));
      const notesPrintPN = pdfProgressNotes.filter(x => !checkTrue(x.isorder));
      printPN = {
        Orders: ordersPrintPN,
        Notes: notesPrintPN
      };
      widgetTitle = defaults.ordersAndNotes;
      isCombined = true;
    }
  }

  return /*#__PURE__*/React.createElement(Page, {
    wrap: false,
    size: pageSize,
    orientation: pageOrientation,
    style: browser && browser.name === safari || browser && browser.name === ios ? styles.pageSafari : styles.page
  }, /*#__PURE__*/React.createElement(PrintHeaderPDFComponent, {
    browser: browser,
    patient: patient
  }), /*#__PURE__*/React.createElement(View, {
    style: [styles.textAlignCenter, styles.width100, styles.marginBottomPointFiveCm]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.printerHeaderText]
  }, widgetTitle), dashboardPrintConfig && dashboardPrintConfig.fromDate && dashboardPrintConfig.toDate && /*#__PURE__*/React.createElement(Text, {
    style: [styles.fontFamilyItalic, styles.fontSizeTenPt, styles.marginYPointTwoCm]
  }, fromDateToDate(dashboardPrintConfig))), /*#__PURE__*/React.createElement(AllProgressNotesPDF, {
    ordersPageConfig: ordersPageConfig,
    widgetTitle: widgetTitle,
    notes: printPN,
    isCombined: isCombined,
    pdfPSOComponents: pdfPSOComponents,
    dashboardPrintConfig: dashboardPrintConfig
  }), _ref);
};